import { Controller } from "@hotwired/stimulus"

// Admin tables (.admin-table) collapse into label/value stacks below the
// `md` breakpoint instead of horizontal-scrolling (see the .admin-table
// rules in admin.tailwind.css) — most have 6-8 columns that don't fit a
// phone screen even scrolled. The stacked layout reads each row's label
// from a `data-label` attribute on its <td>, which this controller fills
// in from the matching <thead th> text so callers don't have to repeat
// every column label on every cell.
export default class extends Controller {
  connect() {
    const headerCells = this.element.querySelectorAll("thead th")
    if (!headerCells.length) return

    const labels = Array.from(headerCells).map((th) => th.textContent.trim())

    this.element.querySelectorAll("tbody tr").forEach((row) => {
      Array.from(row.children).forEach((cell, index) => {
        if (labels[index]) cell.setAttribute("data-label", labels[index])
      })
    })
  }
}
